module.exports = __webpack_public_path__ + "static/haveneer-logo-drakkar-01ace39c170827e037abb75bd135c757.svg";